module.exports = __webpack_public_path__ + "img/hf_logo_w_partners.d758bee2.png";